export enum RegionStatusEnum {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}